// extracted by mini-css-extract-plugin
export var gif = "_lr-0";